<div *ngIf="stateService.dashboard" id="kt_body" class="header-fixed header-mobile-fixed subheader-enabled subheader-fixed">
    <router-outlet></router-outlet>
</div>
<div *ngIf="!stateService.dashboard"  id="kt_body" class="header-fixed header-mobile-fixed subheader-enabled subheader-fixed aside-enabled aside-fixed aside-minimize-hoverable page-loading">
    <router-outlet></router-outlet>
</div>
